"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DependencyPersonToEventInvitation = exports.Person = void 0;
const obejct_diff_1 = require("../utils/obejct-diff");
const network_constants_1 = require("./network.constants");
class Person {
    constructor() {
        this.className = "Person";
        this._structureVersion = "1.0";
        this.identifier = undefined;
        this.contextId = undefined;
        this.emailAddresse = undefined;
        this.vorname = undefined;
        this.eventLeader = undefined;
        this.groupLeader = undefined;
        this.nachname = undefined;
        this.telefon = undefined;
        this.anzeigeName = undefined;
        this.geschlecht = undefined;
        this.reportGroup = undefined;
        this.hundeJagdlichImTreiben = undefined;
        this.hundeNachsucheGespann = undefined;
        this.legalPersonalAddress = undefined;
        this.billingAddress = undefined;
        this.creationDate = undefined;
        this.updateTimestamp = undefined;
        this.anrede = undefined;
        this.titelAkademisch = undefined;
        this.titelAndere = undefined;
        this.kommentar = undefined;
    }
    getListItemTitle() {
        return this.anzeigeName;
    }
    setFromAny(element) {
        const { identifier, contextId, emailAddresse, vorname, eventLeader, groupLeader, nachname, telefon, anzeigeName, geschlecht, reportGroup, hundeJagdlichImTreiben, hundeNachsucheGespann, legalPersonalAddress, billingAddress, creationDate, updateTimestamp, anrede, titelAkademisch, titelAndere, invitationRef, kommentar, reportGroupTitle, reportGroupId } = element;
        this.identifier = identifier ? identifier : this.identifier;
        this.contextId = contextId ? contextId : this.contextId;
        this.emailAddresse = emailAddresse ? emailAddresse : this.emailAddresse;
        this.vorname = vorname ? vorname : this.vorname;
        this.eventLeader = eventLeader ? eventLeader : this.eventLeader;
        this.groupLeader = groupLeader ? groupLeader : this.groupLeader;
        this.nachname = nachname ? nachname : this.nachname;
        this.telefon = telefon ? telefon : this.telefon;
        this.anzeigeName = anzeigeName ? anzeigeName : this.anzeigeName;
        if (!this.anzeigeName && (vorname && nachname))
            this.anzeigeName = `${vorname} ${nachname}`;
        this.geschlecht = geschlecht ? geschlecht : this.geschlecht;
        this.reportGroup = reportGroup ? reportGroup : this.reportGroup;
        this.hundeJagdlichImTreiben = hundeJagdlichImTreiben ? hundeJagdlichImTreiben : this.hundeJagdlichImTreiben;
        this.hundeNachsucheGespann = hundeNachsucheGespann ? hundeNachsucheGespann : this.hundeNachsucheGespann;
        this.legalPersonalAddress = legalPersonalAddress ? legalPersonalAddress : this.legalPersonalAddress;
        this.billingAddress = billingAddress ? billingAddress : this.billingAddress;
        this.creationDate = creationDate ? (0, obejct_diff_1.isDate)(creationDate) ? creationDate : (0, obejct_diff_1.firestoreTimestampToDate)(creationDate) : this.creationDate;
        this.updateTimestamp = updateTimestamp ? (0, obejct_diff_1.isDate)(updateTimestamp) ? updateTimestamp : (0, obejct_diff_1.firestoreTimestampToDate)(updateTimestamp) : this.updateTimestamp;
        this.anrede = anrede ? anrede : this.anrede;
        this.titelAkademisch = titelAkademisch ? titelAkademisch : this.titelAkademisch;
        this.titelAndere = titelAndere ? titelAndere : this.titelAndere;
        this.kommentar = kommentar ? kommentar : this.kommentar;
        this.invitationRef = invitationRef ? invitationRef : this.invitationRef;
        this.reportGroupId = reportGroupId ? reportGroupId : this.reportGroupId;
        this.reportGroupTitle = reportGroupTitle ? reportGroupTitle : this.reportGroupTitle;
    }
    searchFilter(filter) {
        const str = `${this.anzeigeName}${this.emailAddresse}${this.nachname}${this.vorname}`.toLowerCase();
        return str.includes(filter);
    }
    /**
     * Function for skipping objects and data while deepcopying class.
     * used as optional Input for deepCopy(any, replacerFn)
     * @param key
     */
    replacerFn(key) {
        if (key == "className")
            return false;
        else
            return true;
    }
}
exports.Person = Person;
Person.className = "Person";
exports.DependencyPersonToEventInvitation = {
    collectionName: network_constants_1.NetworkConstants.COLLECTION_EVENT_INV,
    mapping: new Map([
        ["emailAddresse", "personEmailAddresse"],
        ["nachname", "personNachname"],
        ["vorname", "personVorname"],
        ["anzeigeName", "personAnzeigeName"],
        ["geschlecht", "personGeschlecht"],
        ["anrede", "personAnrede"],
        ["titelAkademisch", "personTitelAkademisch"],
        ["titelAndere", "personTitelAndere"],
        ["telefon", "personTelefon"],
        ["legalPersonalAddress.zip", "personLegalPersonalAddress.zip"],
        ["legalPersonalAddress.address1", "personLegalPersonalAddress.address1"],
        ["legalPersonalAddress.address2", "personLegalPersonalAddress.address2"],
        ["legalPersonalAddress.city", "personLegalPersonalAddress.city"],
        ["legalPersonalAddress.county", "personLegalPersonalAddress.county"],
        ["legalPersonalAddress.country", "personLegalPersonalAddress.country"],
        ["billingAddress.zip", "personBillingAddress.zip"],
        ["billingAddress.address1", "personBillingAddress.address1"],
        ["billingAddress.address2", "personBillingAddress.address2"],
        ["billingAddress.city", "personBillingAddress.city"],
        ["billingAddress.county", "personBillingAddress.county"],
        ["billingAddress.country", "personBillingAddress.country"],
    ]),
    getQuery: (firestore, origin, now) => {
        return (now != null) ? firestore.collection(network_constants_1.NetworkConstants.COLLECTION_EVENT_INV)
            .where('personId', '==', origin['identifier'])
            .where('eventDate', '>=', now)
            :
                firestore.collection(network_constants_1.NetworkConstants.COLLECTION_EVENT_INV)
                    .where('personId', '==', origin['identifier']);
    },
    getDoc: (firestore, identifier) => {
        return null;
    }
};
